export default __webpack_public_path__ + "static/media/logo-raya.a895e223.png";